"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOfflineMutation = void 0;
var apollo_client_1 = require("apollo-client");
var react_1 = __importDefault(require("react"));
var ApolloOfflineProvider_1 = require("./ApolloOfflineProvider");
var utils_1 = require("./utils");
function actHack(callback) {
    callback();
}
var getInitialState = function () { return ({
    called: false,
    data: undefined,
    error: undefined,
    hasError: false,
    loading: false,
    calledWhileOffline: false
}); };
function isOfflineError(error) {
    return (error.offline);
}
function useOfflineMutation(mutation, options) {
    if (options === void 0) { options = {}; }
    var client = ApolloOfflineProvider_1.useApolloOfflineClient(options.client);
    var _a = react_1.default.useState(getInitialState), result = _a[0], setResult = _a[1];
    var mergeResult = function (partialResult) {
        // A hack to get rid React warnings during tests.
        actHack(function () {
            setResult(function (prev) { return (__assign(__assign({}, prev), partialResult)); });
        });
    };
    // reset state if client instance changes
    react_1.default.useEffect(function () {
        mergeResult(getInitialState());
    }, [client]);
    var _b = useMutationTracking(), generateNewMutationId = _b.generateNewMutationId, isMostRecentMutation = _b.isMostRecentMutation;
    var onMutationStart = function () {
        if (!result.loading) {
            mergeResult({
                called: true,
                data: undefined,
                error: undefined,
                hasError: false,
                loading: true
            });
        }
    };
    var onMutationError = function (error, mutationId) {
        if (isMostRecentMutation(mutationId)) {
            mergeResult({
                error: error,
                hasError: true,
                loading: false,
                calledWhileOffline: isOfflineError(error)
            });
        }
    };
    var onMutationCompleted = function (response, mutationId) {
        var data = response.data, errors = response.errors;
        if (errors && errors.length > 0) {
            onMutationError(new apollo_client_1.ApolloError({ graphQLErrors: errors }), mutationId);
            return;
        }
        if (isMostRecentMutation(mutationId)) {
            mergeResult({
                data: data,
                loading: false
            });
        }
    };
    var runMutation = react_1.default.useCallback(function (mutateOptions) {
        if (mutateOptions === void 0) { mutateOptions = {}; }
        return new Promise(function (resolve, reject) {
            onMutationStart();
            var mutationId = generateNewMutationId();
            // merge together variables from baseOptions (if specified)
            // and the execution
            var mutateVariables = options.variables
                ? __assign(__assign({}, mutateOptions.variables), options.variables) : mutateOptions.variables;
            client
                .offlineMutate(__assign(__assign(__assign({ mutation: mutation }, options), mutateOptions), { variables: mutateVariables }))
                .then(function (response) {
                onMutationCompleted(response, mutationId);
                resolve(response);
            })
                .catch(function (err) {
                onMutationError(err, mutationId);
                reject(err);
            });
        });
    }, [client, mutation, utils_1.objToKey(options)]);
    return [runMutation, result];
}
exports.useOfflineMutation = useOfflineMutation;
function useMutationTracking() {
    var mostRecentMutationId = react_1.default.useRef(0);
    var generateNewMutationId = function () {
        mostRecentMutationId.current += 1;
        return mostRecentMutationId.current;
    };
    var isMostRecentMutation = function (mutationId) {
        return mostRecentMutationId.current === mutationId;
    };
    return { generateNewMutationId: generateNewMutationId, isMostRecentMutation: isMostRecentMutation };
}
